<div class="message message-warning" data-testid="<%= testIds.booking.error %>">
  <%- error_messages.base_epic_invalid_date_error %>
</div>
